<template>
  <div class="main">
    <div class="title">
    	<div class="t-main">商事法律实践专栏</div>
    	<div class="t-desc">- COMMERCIAL LAW COLUM -</div>
    </div>
    <div class="list">
    	<div v-for="(item , index) in List" :key="index"  class="lists" @click="$router.push({name: 'lawColumnInfo', params: {law_id: item.id,type:'column'}})">
    		<div class="l-left">
    			<img :src="$avatarHash(item.uid)" class="list-img" @click.stop="$router.push({name: 'personalCenter', params: {id: item.uid}})">
    			<img v-if="item.is_vip" src="/static/img/isviplawyer.png" class="l-isvip">
    			<div class="l-name">{{item.real_name}}<img src="/static/img/islawyer.png" class="name-img"></div>
    			<div class="l-tag">{{item.hobby_name[0]}}</div>
    		</div>
    		<div class="l-right">
    			<div class="r-title">{{item.title}}</div>
    			<div class="r-desc">{{item.desc}}</div>
    			<div class="r-bottom">
    				<div>{{item.updated_at}}</div>
    				<div>|</div>
    				<div class="r-bottom-btn"  @click.stop="praise(item,index)" title="点赞">
    					<img v-if="item.is_praised" src="/static/img/praise_is.png">
    					<img v-else src="/static/img/praise.png">
    					<div>{{item.praise_num}}</div>
    				</div>
    				<div class="r-bottom-btn" title="评论">
    					<img src="/static/img/praise2.png">
    					<div>{{item.comment_num}}</div>
    				</div>
    				<div class="r-bottom-btn"  @click.stop="collect(item,index)" title="收藏">
    					<img v-if="item.is_collected" src="/static/img/praise3_is.png">
    					<img v-else src="/static/img/praise3.png">
    					<div>{{item.collect_num}}</div>
    				</div>
    			</div>
    		</div>
    		<div v-if="item.real_price != 0" class="l-pay">
    			<img v-if="item.is_pay == 1" src="/static/img/law_post_ispay.png"></img>
    			<img v-else src="/static/img/law_post_nopay.png"></img>
    		</div>
    	</div>
    </div>
    <div class="bottom" v-if="total > perpage">
	    <el-pagination
		  background
		  :current-page.sync="page"
		  :page-size="perpage"
		  @current-change="handleCurrentChange"
		  layout="prev, pager, next, total"
		  :total="total">
		</el-pagination>
	</div>
  </div>
</template>

<script>
export default {
  name: 'CommercialLawColumn',
  data () {
    return {
      List:[],
      page:1,
      total:0,
      perpage: 8,
    }
  },
  mounted(){
  	this.getList();
  },
  methods:{
  	getList(){
  		let url = 'lawArticle/getArticleList';
  		let param = {
  			page:this.page,
  			per_page:8
  		};
  		this.$http.get(url, {params:param} ).then(res => {
  			if(res.data.retcode == $conf.RETCODE_OK){
  				this.List = res.data.data.data;
  				this.total = res.data.data.total;
  			}
  		})
  	},
  	handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    praise(item,index){
    	if (!this.$store.state.loginStatus) {
            this.$Message.warning('请先登录后再进行评论！');
            return false;
        };
  		if(item.is_praised){
  			var params = {
  				type:'cancel_praise',
  				art_id : item.id
  			}
  		}else{
  			var params = {
  				type:'praise',
  				art_id : item.id
  			}
  		};
  		var url = 'lawArticle/praise';
  		this.$http.post(url , params).then(res =>{
  			if(res.data.retcode == $conf.RETCODE_OK){
  				if(item.is_praised){
		  			this.List[index].is_praised = false;
		  			this.List[index].praise_num -= 1;
		  		}else{
		  			this.List[index].is_praised = true;
		  			this.List[index].praise_num += 1;
		  		}
  			}
  		})
  	},
  	collect(item,index){
  		if (!this.$store.state.loginStatus) {
            this.$Message.warning('请先登录后再进行评论！');
            return false;
        };
  		if(item.is_collected){
  			var params = {
  				type:'cancel_collect',
  				art_id : item.id
  			}
  		}else{
  			var params = {
  				type:'collect',
  				art_id : item.id
  			}
  		};
  		var url = 'lawArticle/collect';
  		this.$http.post(url , params).then(res =>{
  			if(res.data.retcode == $conf.RETCODE_OK){
  				if(item.is_collected){
		  			this.List[index].is_collected = false;
		  			this.List[index].collect_num -= 1;
		  		}else{
		  			this.List[index].is_collected = true;
		  			this.List[index].collect_num += 1;
		  		}
  			}
  		})
  	},
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	background:#FFFFFF;
	padding:0 15%;
	.title
		display:flex;
		flex-direction:column;
		align-items:center;
		padding-top:50px;
		margin-bottom:40px;
		.t-main
			height:59px;
			font-size:42px;
			font-weight:400;
			color:rgba(7,19,54,1);
			line-height:59px;
			margin-bottom:10px;
		.t-desc
			height:22px;
			font-size:16px;
			font-weight:400;
			color:rgba(7,19,54,0.4);
			line-height:22px;
	.list
		margin-top:15px;
		display:flex;
		flex-wrap: wrap;
		width:1320px;
		margin-bottom:70px;
		.lists
			width: 660px;
			height: 156px;
			margin: 20px 0px;
			display:flex;
			position: relative;
			cursor:pointer
			.l-left
				margin:23px 15px;
				text-align:center;
				position: relative;
				.list-img
					width:60px;
					height:60px;
					border-radius:50%;
				.l-isvip
					width:21px;
					height:21px;
					position: absolute;
					right:5px;
					bottom:50px;
				.l-name
					height:22px;
					font-size:16px;
					font-weight:500;
					color:rgba(102,102,102,1);
					line-height:22px;
					margin-top:6px;
					.name-img
						width:13px;
						height:15px;
						margin-left:3px;
				.l-tag
					width:75px;
					height:23px;
					line-height:23px;
					background:rgba(243,243,243,1);
					border-radius:12px;
					text-align:center;
					font-weight:400;
					color:rgba(156,156,156,1);
					font-size:11px;
					margin-top:4px;
			.l-right
				margin:23px 20px;
				width:75%;
				.r-title
					height:28px;
					font-size:20px;
					font-weight:600;
					color:rgba(51,51,51,1);
					line-height:28px;
					white-space:nowrap;
					overflow:hidden;
					text-overflow:ellipsis;
				.r-desc
					height:50px;
					font-size:14px;
					font-weight:400;
					color:rgba(102,102,102,1);
					line-height:25px;
					overflow:hidden;
					text-overflow:ellipsis;
					display:-webkit-box;
					-webkit-box-orient:vertical;
					-webkit-line-clamp:2;
					margin-top:10px;
				.r-bottom
					margin-top:16px;
					display:flex;
					align-items:center;
					height:17px;
					font-size:12px;
					font-weight:400;
					color:rgba(51,51,51,0.6);
					line-height:17px;
					.r-bottom-btn
						display:flex;
						align-items:center;
						height:17px;
						line-height:17px;
						div
							margin-right:15px;
							height:16px;
							line-height:16px;
						img
							width:16px;
							height:16px;
							margin-right:6px;
					div
						margin-right:15px;
			.l-pay
				position: absolute;
				right:10px;
				top:10px;
	.bottom
		margin-bottom:70px;
		text-align:center;
</style>


// WEBPACK FOOTER //
// src/components/common/commercialLawColumn.vue